import { ExistingFileTypes, FileForDocumentsForm, FileProps } from 'types/file'

export const getHiddenRecognizedFileUuids = (files?: FileProps[] | null): Set<string> => {
  if (!files?.length) return new Set()

  return new Set(
    files
      .filter((file) => file.data?.isDeleted)
      .flatMap((file) => (file.data?.recognizedFiles ?? []).map((recognizedFile) => recognizedFile.href_file)),
  )
}

const isHiddenInRecognizedDocuments = (file: FileProps, hiddenUuids: Set<string>) => Boolean(file.data?.isDeleted) || hiddenUuids.has(file.uuid)

export const getImagesPreview = (files: FileProps[]) => {
  const hiddenUuids = getHiddenRecognizedFileUuids(files)

  return files?.reduce((list: FileForDocumentsForm[], item: any) => {
    if (isHiddenInRecognizedDocuments(item, hiddenUuids)) return list

    if (!item?.data?.entity && !item?.data?.type && (item?.data?.inSlot || item?.data?.recognitionType)) {
      return [...list, { href_file: item.uuid, data: item.data ?? null, name: item.name }]
    }

    return list
  }, [])
}

export const getImages = (files: FileProps[]) => {
  const hiddenUuids = getHiddenRecognizedFileUuids(files)

  const { slotFiles, recognitionFiles } = files?.reduce(
    (result: { slotFiles: FileForDocumentsForm[]; recognitionFiles: FileForDocumentsForm[] }, item: any) => {
      if (isHiddenInRecognizedDocuments(item, hiddenUuids)) return result

      const elem = { name: item.name, href_file: item.uuid, data: item.data, type: null }
      return item?.data?.inSlot
        ? { ...result, slotFiles: [...result.slotFiles, elem] }
        : { ...result, recognitionFiles: [...result.recognitionFiles, elem] }
    },
    { slotFiles: [], recognitionFiles: [] },
  )

  return [...slotFiles, ...recognitionFiles]
}

export const getExistingTypesOfImages = (files: FileForDocumentsForm[]) =>
  files?.reduce((list: ExistingFileTypes[], item: FileForDocumentsForm) => {
    return item?.data?.type ? [...list, { type: item?.data?.type, entity: item?.data?.entity || null, inSlot: item.data?.inSlot }] : list
  }, [])
